/* eslint-disable @typescript-eslint/no-explicit-any */
import CarCard from '@apps/components/CarCard';
import {
  DesktopPaginationWrapper,
  MbPaginationWrapper,
} from '@apps/containers/NewsListing/styles';
import { TypographyProps } from '@mui/material';
import Grid, { GridProps } from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ResultNotFound from '@stack/assets/images/result-not-found.png';
import { Pagination, TitleDivider } from '@stack/ui/components';
import { PaginationProps } from '@stack/ui/components/Pagination/props';
import Image from 'next/image';

export type CarListingSectionProps = GridProps & {
  cars: CarType[];
  webView?: boolean;
  title?: string;
  containerProps?: GridProps;
  href?: string;
  pagination?: PaginationProps;
  imageWrapperProps?: {
    width: string;
    height: string;
  };
  nameProps?: TypographyProps;
};

export type CarType = {
  car_model_slug: string;
  new_car_title: string;
  car_model_image: string;
  new_car_monthly_instalment_9: number;
  lowest_price: number;
  highest_price: number;
  car_brand_slug: string;
  new_car_slug: string;
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const CarListingSection: React.FC<CarListingSectionProps> = (props) => {
  const {
    cars,
    title,
    containerProps,
    webView,
    pagination,
    imageWrapperProps,
    nameProps,
    ...rest
  } = props;
  if (!cars || cars.length < 1)
    return (
      <TitleDivider title={title}>
        <Stack sx={{ alignItems: 'center', justifyContent: 'center' }}>
          <Image
            width={250}
            height={200}
            src={ResultNotFound}
            alt={'placeholder'}
          />
        </Stack>
        <Typography sx={{ textAlign: 'center' }}>
          {'No Results Found.'}
        </Typography>
      </TitleDivider>
    );
  // ======================= HOOKS

  // ======================= VIEWS
  return (
    <TitleDivider title={title}>
      <Grid
        container
        spacing={3}
        rowGap={{ xs: 3, md: 8 }}
        sx={{ mb: 10 }}
        {...containerProps}
      >
        {cars.map((car, index: number) => {
          return (
            <Grid key={`new-car-${index}`} item xs={12} md={3} {...rest}>
              <CarCard
                key={index}
                slug={car?.new_car_slug}
                name={car?.new_car_title}
                image={car?.car_model_image}
                monthlyPayment={car?.new_car_monthly_instalment_9}
                priceRange={[car?.lowest_price, car?.highest_price]}
                brand={car?.car_brand_slug}
                isNewCar={true}
                webView={webView}
                containerProps={{
                  sx: {
                    flexDirection: {
                      xs: 'row',
                      md: 'column',
                    },
                    position: 'relative',
                    justifyContent: {
                      xs: 'flex-start',
                      md: 'center',
                    },
                  },
                }}
                imageWrapperProps={imageWrapperProps}
                nameProps={nameProps}
              />
            </Grid>
          );
        })}
      </Grid>
      {pagination && (
        <>
          <DesktopPaginationWrapper
            style={{
              position: 'relative',
            }}
          >
            <Pagination
              className="pagination-bar"
              {...pagination}
              siblingCount={2}
            />
          </DesktopPaginationWrapper>
          <MbPaginationWrapper>
            <Pagination
              className="pagination-bar"
              {...pagination}
              siblingCount={1}
            />
          </MbPaginationWrapper>
        </>
      )}
    </TitleDivider>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default CarListingSection;
